import { useNode } from '@craftjs/core';
import { upperFirst } from 'lodash';
import {
	AutocompleteControl,
	SwitchControl,
	ToggleButtonGroupControl
} from 'pages/PageEditor/settingsComponents';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import {
	horizontalAlignmentOptions,
	TypographyVariantsOptions
} from '../constants';

const EditorTextSettings = () => {
	const {
		typography,
		align,
		fullWidth,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onTypographyChange, onAlignChange, onFullWidthChange] = useMemo(
		() =>
			['typography', 'align', 'fullWidth'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	return (
		<div>
			<AutocompleteControl
				label={intl.tr('screenEditor.settings.style')}
				setValue={onTypographyChange}
				value={typography}
				options={TypographyVariantsOptions}
				getOptionLabel={(o) => upperFirst(o as string)}
			/>

			<ToggleButtonGroupControl
				data-testid="horizontal-alignment"
				label={intl.tr('screenEditor.settings.alignment')}
				options={horizontalAlignmentOptions}
				value={align}
				setValue={onAlignChange}
			/>
			<SwitchControl
				value={fullWidth}
				label={intl.tr('screenEditor.settings.fullWidth')}
				setValue={onFullWidthChange}
			/>
		</div>
	);
};

export { EditorTextSettings };
